import type { PropsWithChildren } from 'react'
import { createPortal } from 'react-dom'

import useRootLayoutDirection from '~/@app/hooks/useLayout'

import authService from '../services/auth.service'

type Props = PropsWithChildren & {
  key?: string | null
  isSideHeaderLayoutMode?: boolean
}

// layout 최상위에 있는 헤더
export const PortalRootLayoutHeader = ({
  children,
  key,
  isSideHeaderLayoutMode = false,
}: Props) => {
  useRootLayoutDirection(isSideHeaderLayoutMode)

  if (!authService.isLoggedIn) return null

  return createPortal(
    <div className="app-layout-header">{children}</div>,
    document.getElementById('layout-header')!,
    key,
  )
}
